import { ReactNode, createContext, useContext } from 'react';

/**
 * Which list the filters around it belong to.
 *
 * The hand-written filters inside the panel are written once and used by
 * several lists, so they cannot name the list themselves — and some of them
 * have to ask it what it holds (#2231 R-128).
 */
const PaloListKeyContext = createContext<string | undefined>(undefined);

export const PaloListKeyProvider = ({ listKey, children }: { listKey?: string; children: ReactNode }): JSX.Element => (
    <PaloListKeyContext.Provider value={listKey}>{children}</PaloListKeyContext.Provider>
);

export const usePaloListKey = (): string | undefined => useContext(PaloListKeyContext);
